import { formatToDdMmYyyyHHmm } from '@/utils';

import type {
  AuditFilterOption,
  AuditRecord,
  AuditRecordsPage,
  LC_AuditFilterItemOut,
  LC_AuditUserFilterItemOut,
  LC_AuditRecordOut,
  LC_ListAuditRecordsOut,
} from './types';


export function mapAuditRecordOutToModel(record: LC_AuditRecordOut, index: number): AuditRecord {
  return {
    id: String(index),
    date: formatToDdMmYyyyHHmm(record.date),
    user: record.user ?? '',
    entity: record.entity ?? '',
    action: record.action ?? '',
    program: record.program ?? '',
    detail: record.detail,
    origin: record.origin,
    objectId: record.objectId,
    changes: record.changes != null ? JSON.stringify(record.changes) : null,
    ipUser: record.ipUser,
  };
}

export function mapAuditPagedResultToModel(pagedResult: LC_ListAuditRecordsOut): AuditRecordsPage {
  return {
    data: pagedResult.data?.map(mapAuditRecordOutToModel) ?? [],
    page: pagedResult.pagination?.currentPage ?? 1,
    pageSize: pagedResult.pagination?.pageSize ?? 10,
    totalRecords: pagedResult.pagination?.totalRecords ?? 0,
    totalPages: pagedResult.pagination?.totalPages ?? 0,
  };
}

export function mapAuditFilterItemToOption(
  item: LC_AuditFilterItemOut,
): { value: string; label: string } {
  return {
    value: item.value,
    label: item.label,
  };
}

export function mapAuditFilterOptionToSelectOption(
  item: AuditFilterOption,
): { value: string; label: string } {
  return {
    value: item.id,
    label: item.name,
  };
}

export function mapAuditFilterItemToModel(item: LC_AuditFilterItemOut): AuditFilterOption {
  return {
    id: item.value,
    name: item.label,
  };
}

export function mapAuditUserFilterItemToModel(item: LC_AuditUserFilterItemOut): AuditFilterOption {
  return {
    id: item.user,
    name: item.user,
  };
}
